export enum TypeStar {
    FULL = 'full',
    HALF = 'half',
    EMPTY = 'empty'
}
